var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content",class:_vm.$router.currentRoute.name},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item profile-content"})])
}]

export { render, staticRenderFns }